import {
	REQUEST_LAST_CHANGES,
	RECEIVE_LAST_CHANGES,
	LAST_CHANGES_ERROR,
	REQUEST_PROCESS_OWNER,
	RECEIVE_PROCESS_OWNER,
	PROCESS_OWNER_ERROR,
} from "../actions/revisionsActions";
const initialRevisionState = {
	isFetching: false,
	items: {
		diff: {
			changedStates: [],
			changedIemClasses: [],
			differencesCount: 0,
		},
		modelId: "",
		revisionPost: "",
		revisionPrev: "",
		processOwner: {},
	},
	error: null,
};

export const revisionsReducer = (state = initialRevisionState, action) => {
	switch (action.type) {
		case REQUEST_LAST_CHANGES:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_LAST_CHANGES:
			//sets new state and fetching ended
			if (action.payload.message === "need more than 1 model revision") {
				return initialRevisionState;
			} else {
				return {
					...state,
					items: {
						...state.items,
						diff: action.payload.diff,
						modelId: action.payload.requestedModel,
						revisionPost: action.payload.revisionPost,
						revisionPrev: action.payload.revisionPrev,
					},
					isFetching: false,
				};
			}
		case LAST_CHANGES_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_PROCESS_OWNER:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_PROCESS_OWNER:
			//sets new state and fetching ended

			return {
				...state,
				items: {
					...state.items,
					processOwner: action.payload,
				},
				isFetching: false,
			};
		case PROCESS_OWNER_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };

		default:
			return state;
	}
};
